module.exports = __webpack_public_path__ + "media/images/icons/country_flags/sd-d7f3b46827654083de6fa94d8f535226.svg";